import dayjs from 'dayjs';
import { IWorkState } from 'models';

const transform = (arr: string[]) => {
	return arr.map((el) => ({
		value: el,
		label: el
	}));
};

export const moversS = transform(['2 movers', '3 movers', '4 movers', '5 movers', '6 movers']);

export const trucksS = [
	{ value: 'sixteen0', label: '0 - 16ft' },
	{ value: 'twentySix1', label: '1 - 26ft' },
	{ value: 'twentySix2', label: '2 - 26ft' },
	{ value: 'twentySix3', label: '3 - 26ft' },
	{ value: 'twenty4', label: '4 - 20ft' },
	{ value: 'twenty5', label: '5 - 20ft' },
	{ value: 'sixteen6', label: '6 - 16ft' }
];

export const paymentS = transform(['cash', 'Credit card', 'Venmo', 'Zelle']);

export const bedroomS = transform([
	'Studio',
	'1 bedroom',
	'2 bedroom',
	'3 bedroom',
	'4 bedroom',
	'5 bedroom',
	'6 bedroom'
]);

export const truckSizeS = transform(['No truck just a labor', '16 feet', '20 feet', '26 feet']);

export const typeOfResS = transform(['Apartment', 'House', 'Townhouse', 'Storage', 'Office', 'Other']);

export const heavyItemsS = transform(['Piano', 'Safe', 'Other', 'No']);

export const packingS = transform(['No Packing', 'Partial Packing', 'Full Packing']);

export const referralS = transform(['Yelp', 'Google', 'Referral', 'Moved', 'Thumbtack', 'Other']);

export const timeS = [
	{ value: '07:00', label: '7 am' },
	{ value: '08:00', label: '8 am' },
	{ value: '09:00', label: '9 am' },
	{ value: '10:00', label: '10 am' },
	{ value: '11:00', label: '11 am' },
	{ value: '12:00', label: '12 pm' },
	{ value: '13:00', label: '13 pm' },
	{ value: '14:00', label: '14 pm' },
	{ value: '15:00', label: '15 pm' },
	{ value: '16:00', label: '16 pm' },
	{ value: '17:00', label: '17 pm' },
	{ value: '18:00', label: '18 pm' },
	{ value: '19:00', label: '19 pm' }
];

export const timeRange = transform([
	'0:00',
	'0:15',
	'0:30',
	'0:45',
	'1:00',
	'1:15',
	'1:30',
	'1:45',
	'2:00',
	'2:15',
	'2:30',
	'2:45',
	'3:00',
	'3:15',
	'3:30',
	'3:45',
	'4:00',
	'4:15',
	'4:30',
	'4:45',
	'5:00',
	'5:15',
	'5:30',
	'5:45',
	'6:00',
	'6:15',
	'6:30',
	'6:45',
	'7:00',
	'7:15',
	'7:30',
	'7:45',
	'8:00',
	'8:15',
	'8:30',
	'8:45',
	'9:00',
	'9:15',
	'9:30',
	'9:45',
	'10:00',
	'10:15',
	'10:30',
	'10:45',
	'11:00',
	'11:15',
	'11:30',
	'11:45',
	'12:00',
	'12:15',
	'12:30',
	'12:45'
]);

export const statusSManager = [
	{
		value: IWorkState.QUOTE,
		text: 'Quote'
	},
	{
		value: IWorkState.CONFIRMED,
		text: 'Confirmed'
	}
];

export const statusSAdmin = [
	...statusSManager,
	{
		value: IWorkState.ASSIGN_WORKERS,
		text: 'In progress'
	},
	{
		value: IWorkState.COMPLETED,
		text: 'Completed'
	},
	{
		value: IWorkState.LOST,
		text: 'Lost'
	},
	{
		value: IWorkState.PENDING,
		text: 'Pending'
	}
];

export function isWeekend(date?: string) {
	const day = dayjs(date).day();
	return day === 0 || day === 6;
}

export function isCash(payment?: string) {
	return payment === 'cash' || payment === 'Zelle';
}

export const followUpsMessages = [
	'Hi! Did you get a chance to look over the quote I sent? If you’d like, I can secure a time slot for you right now or walk you through any part of it. Just reply here and I’ll take care of everything. 🤝',
	'Hi! Sharing a few quick moving tips while you plan: Label boxes by room, use suitcases for heavier stuff, and keep essentials together for the first night. If you want me to check availability for your preferred day, just let me know and I’ll hold a spot for you.',
	'Hi! Following up on your move. We have openings for your date, and I can lock in the rate and the crew for you today. Would you like me to reserve the time window?',
	'Hi, this will be my last message. I’d still love to help make your move easy and predictable. If you’d like to go ahead and get a spot on the schedule, just reply here and I’ll book everything for you. If not, wishing you a smooth move either way.'
];